import { render, staticRenderFns } from "./ModalFoto.vue?vue&type=template&id=125dc027"
import script from "./ModalFoto.vue?vue&type=script&lang=js"
export * from "./ModalFoto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports